// extracted by mini-css-extract-plugin
export var container = "blogpostSuggestionFooter-module--container--WOuwt";
export var flex_container = "blogpostSuggestionFooter-module--flex_container--NDZmv";
export var suggested_posts = "blogpostSuggestionFooter-module--suggested_posts--GUSx0";